/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/462-delicious': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 0v16h16V0H0zm8 15V8H1V1h7v7h7v7H8z"/>'
  }
})
